<template>
    <v-app>
        <div v-if="!isLoading">
            <v-card class="outer-wrapper" flat v-if="audienceList.length">
                <v-layout justify-space-between row wrap>
                    <v-flex md4>
                        <h2 class="title font-weight-medium" style="margin: 15px 0;">Audience Analyses</h2>
                    </v-flex>
                    <v-flex md4 text-xs-right>
                        <v-btn
                                @click="showDialog = true"
                                class="mr-0"
                                color="bindezcolor"
                                dark
                                depressed
                        >
                            <span class="text-capitalize subheading">Add Audience Analysis</span>
                        </v-btn>
                    </v-flex>
                    <v-flex md12>
                        <v-data-table
                                :headers="headers"
                                :items="audienceList"
                                class="elevation-1"
                                hide-actions
                                item-key="id"
                        >
                            <template v-slot:items="props">
                                <tr style="cursor:pointer;" @click="selectAudience(props.item)">
                                    <td class="body-2 table-text--color">{{props.item.analysis_name}}</td>
                                    <td class="body-2 table-text--color">
                                        {{`${props.item.from_date} to ${props.item.to_date}`}}
                                    </td>
                                    <td class="body-2 table-text--color">{{props.item.status}}</td>
                                </tr>
                            </template>
                        </v-data-table>
                        <div class="text-xs-center pt-2">
                            <v-pagination :length="pages" circle color="bindezcolor"
                                          v-model="currentPage"></v-pagination>
                        </div>
                    </v-flex>
                </v-layout>
                <v-dialog
                        persistent
                        v-model="showDialog"
                        width="500"
                >
                    <v-card class="pa-3" height="250">
                        <v-layout column fill-height justify-center wrap>
                            <v-flex text-xs-right>
                                <v-btn
                                        @click="showDialog = false"
                                        class="text-xs-right"
                                        color="#5e7582"
                                        flat
                                        icon
                                >
                                    <v-icon>far fa-times-circle</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex text-xs-center>
                                <h2 class="mb-4 info--color">Want a new Audience Analysis?</h2>
                                <span class="subheading info--color info-about">
                            Please contact <a class="info--color font-weight-bold"
                                              href="mailto:customersuccess@bindez.com">customersuccess@bindez.com</a> or call <span
                                        class="font-weight-bold">+959404060860</span>
                        </span>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-dialog>
            </v-card>
            <AudienceNotAvailable v-else></AudienceNotAvailable>
        </div>
        <div class="text-xs-center" v-else>
            <Spinner/>
            <span class="font-weight-bold display-1 description--color">Loading...</span>
        </div>
    </v-app>
</template>

<script>
	import {mapActions, mapMutations, mapState} from 'vuex';
	import AudienceNotAvailable from "./AudienceNotAvailable";
	import Spinner from "@/components/Spinner";

	export default {
		name: "AudienceAnalysesList",
		components: {AudienceNotAvailable, Spinner},
		props: ["monitor_uuid"],
		data() {
			return {
				headers: [
					{
						text: 'Analysis Name',
						sortable: false,
						value: 'analysis_text',
						align: 'left',
						class: ['font-weight-regular', 'subheading']
					},
					{
						text: 'Date Range',
						sortable: false,
						value: 'date_range',
						align: 'left',
						class: ['font-weight-regular', 'subheading']
					},
					{
						text: 'Status',
						sortable: false,
						value: 'status',
						align: 'left',
						class: ['font-weight-regular', 'subheading']
					}
				],
				pagination: {
					rowsPerPage: 10,
					totalItems: 10
				},
				isLoading: false,
				showDialog: false,
                currentPage: 1,
			}
		},
		computed: {
			...mapState('audience', [
				'audienceList',
                'totalAudiencesCount'
			]),
			pages() {
				if (this.pagination.rowsPerPage == null ||
					this.pagination.totalItems == null
				) return 0;
				return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
			}
		},
		methods: {
			...mapActions('audience', [
				'getAudienceList'
			]),

			...mapMutations('audience', [
				'setDetailAudience',
			]),

			selectAudience(audience) {
				this.setDetailAudience(audience);
				this.$router.push({name: 'audience-analysis'});
			}
		},
		created() {
			this.isLoading = true;
			this.getAudienceList({monitor_uuid:this.monitor_uuid, page:this.currentPage})
				.then(_ => {
					this.$set(this.pagination, 'totalItems', this.totalAudiencesCount);
					this.isLoading = false;
				})
		},
	}
</script>
<style scoped>
    .outer-wrapper {
        padding: 40px;
        top: 8px;
    }

    .table-text--color {
        color: rgba(0, 0, 0, 0.6);
    }

    span.info-about {
        font-size: 20px;
        line-height: 2rem;
    }

    span.info-about a {
        text-decoration: none;
        cursor: pointer;
    }

    .info--color {
        color: #5e7582;
    }
</style>
